import React from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import API, { useCsrfToken } from '@wheeebo/polaris-api';
import { useErrorHandler } from '../../errorHandler';
import Map from './Map';
function SafePortMap({ apiKey, safePortId, editable }) {
    const { csrfToken } = useCsrfToken();
    const { showAndEmitJsErrorEvent } = useErrorHandler();
    const queryClient = useQueryClient();
    const { data, isLoading } = useQuery(API.SafePorts.getKey(safePortId), () => API.SafePorts.get(safePortId));
    const { mutate: updateSafePort } = useMutation((coords) => API.SafePorts.update(csrfToken, safePortId, { latitude: coords.lat, longitude: coords.lng }), {
        onSuccess: () => queryClient.invalidateQueries(API.SafePorts.CacheKey),
        onError: showAndEmitJsErrorEvent,
    });
    const handleDragEnd = React.useCallback((_, coords) => {
        updateSafePort(coords);
    }, [updateSafePort]);
    return (React.createElement(Map, { apiKey: apiKey, safePorts: data ? [data] : undefined, locked: !editable || isLoading, draggable: true, onDragEnd: handleDragEnd }));
}
export default React.memo(SafePortMap);
